// Shared brand assets and content constants

export const LOGOS = {
  main: "https://customer-assets.emergentagent.com/job_dd2858b6-9df7-4c0c-ad7a-51ae1a6fb0d3/artifacts/pro7uu2p_Ping%20Main%20Logo.png",
  laundry: "https://customer-assets.emergentagent.com/job_dd2858b6-9df7-4c0c-ad7a-51ae1a6fb0d3/artifacts/c6meqyzx_Ping%20Laundry.png",
  stitch: "https://customer-assets.emergentagent.com/job_dd2858b6-9df7-4c0c-ad7a-51ae1a6fb0d3/artifacts/cv7t3pkt_Ping%20Stitch.jpeg",
  drive: "https://customer-assets.emergentagent.com/job_dd2858b6-9df7-4c0c-ad7a-51ae1a6fb0d3/artifacts/vk4keb87_Ping%20Drive.png",
  paw: "https://customer-assets.emergentagent.com/job_dd2858b6-9df7-4c0c-ad7a-51ae1a6fb0d3/artifacts/wlklkl2j_Ping%20Paw.png",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "Contact", href: "#contact" },
];

export const PRODUCTS = [
  {
    id: "laundry",
    name: "Ping Laundry",
    caption: "Laundry & dry cleaning shops",
    description:
      "Automatic WhatsApp when laundry is ready. Full customer database built automatically. Seasonal marketing campaigns for Eid and Ramadan.",
    logo: LOGOS.laundry,
    testId: "product-laundry",
  },
  {
    id: "stitch",
    name: "Ping Stitch",
    caption: "Tailor & alteration shops",
    description:
      "Order receipt on drop-off, ready notification on completion. Multi-day jobs managed effortlessly. Never lose a customer record again.",
    logo: LOGOS.stitch,
    testId: "product-stitch",
  },
  {
    id: "drive",
    name: "Ping Drive",
    caption: "Car dealerships · Repair garages · Detailing studios · Body shops",
    description:
      "WhatsApp updates through every stage of a car purchase or service job. Finance status, quote approvals, vehicle ready notifications — all automated.",
    logo: LOGOS.drive,
    testId: "product-drive",
  },
  {
    id: "paw",
    name: "Ping Paw",
    caption: "Pet grooming salons & veterinary clinics",
    description:
      "Admission confirmations, mid-session updates, and discharge notifications. High-anxiety drop-offs handled with professional care.",
    logo: LOGOS.paw,
    testId: "product-paw",
  },
];

export const BUSINESS_TYPES = [
  "Laundry",
  "Tailor",
  "Garage / Detailing / Body shop",
  "Car Dealership",
  "Pet Grooming / Vet Clinic",
  "Other",
];
